import { Type } from 'class-transformer';
import type dayjs from 'dayjs';
import { FunctionRun, FunctionRunStatus } from './function_run';
import type { IntegrationRequestPagination } from './integration_request';
import { Model } from './model';
import { TransformStringToDayJS } from './utils';

export class LinkedModelSync extends Model {
  id: string;

  error: string | null;

  is_initial_sync: boolean;

  model_name: string;

  pagination: IntegrationRequestPagination | null;

  run_id: string;

  @Type(() => FunctionRun)
  run: FunctionRun;

  @TransformStringToDayJS()
  timerange_end: dayjs.Dayjs | null = null;

  @TransformStringToDayJS()
  timerange_start: dayjs.Dayjs | null = null;

  get status(): FunctionRunStatus {
    return this.run.status;
  }

  get isSyncing(): boolean {
    return (
      this.run.status === FunctionRunStatus.QUEUED ||
      this.run.status === FunctionRunStatus.RUNNING ||
      this.run.status === FunctionRunStatus.PENDING_RETRY
    );
  }
}
